import service from '../service';

/**
 * 支付相关API
 */

/**
 * 创建支付订单
 * @param {object} data - 支付订单数据
 * @param {string} data.memberType - 会员类型
 * @param {number} data.amount - 支付金额
 * @param {string} data.payType - 支付类型（alipay/wechat）
 * @param {string} data.description - 支付描述
 * @returns {Promise} 支付订单信息，包含支付链接或二维码
 */
export const createPaymentOrder = (data) => {
    return service({
        url: '/api/payments/create',
        method: 'post',
        data,
    });
};

/**
 * 查询支付订单状态
 * @param {string} transactionId - 交易号
 * @returns {Promise} 支付状态信息
 */
export const checkPaymentStatus = (transactionId) => {
    return service({
        url: `/api/payments/${transactionId}/status`,
        method: 'get',
    });
};

/**
 * 获取支付历史记录
 * @param {object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.size - 每页数量
 * @returns {Promise} 支付历史记录
 */
export const getPaymentHistory = (params) => {
    return service({
        url: '/api/payments/history',
        method: 'get',
        params,
    });
};

/**
 * 确认支付成功（模拟支付完成）
 * @param {string} transactionId - 交易号
 * @returns {Promise} 支付确认结果
 */
export const confirmPaymentSuccess = (transactionId) => {
    return service({
        url: `/api/payments/${transactionId}/simulate-success`,
        method: 'post',
    });
};

/**
 * 检查用户是否有成功的支付记录
 * @returns {Promise} 用户支付状态检查结果
 */
export const checkUserPaymentStatus = () => {
    return service({
        url: '/api/payments/check-user-status',
        method: 'get',
    });
};

/**
 * 删除支付订单
 * @param {number} paymentId - 支付记录ID
 * @returns {Promise} 删除结果
 */
export const deletePaymentOrder = (paymentId) => {
    return service({
        url: `/api/payments/delete/${paymentId}`,
        method: 'delete',
    });
};

/**
 * 根据支付历史更新用户本地缓存状态
 * @returns {Promise} 更新结果
 */
export const updateUserStatusFromPaymentHistory = async () => {
    try {
        const response = await getPaymentHistory({ page: 1, size: 50 });
        if (response.code === 200 && response.data && response.data.records) {
            const hasSuccessfulPayment = response.data.records.some(payment => 
                payment.status === '支付成功' || payment.status === 'PAID'
            );
            
            if (hasSuccessfulPayment) {
                // 更新本地缓存状态
                const userInfo = localStorage.getItem('userInfo');
                if (userInfo) {
                    try {
                        const user = JSON.parse(userInfo);
                        user.feeStatus = 'paid';
                        localStorage.setItem('userInfo', JSON.stringify(user));
                        console.log('根据支付历史更新用户缴费状态为已支付');
                        return { success: true, hasPaid: true };
                    } catch (e) {
                        console.error('更新用户信息失败:', e);
                        return { success: false, error: '更新本地状态失败' };
                    }
                }
            }
            return { success: true, hasPaid: hasSuccessfulPayment };
        }
        return { success: false, error: '获取支付历史失败' };
    } catch (error) {
        console.error('检查支付历史失败:', error);
        return { success: false, error: error.message };
    }
};